import page from '../../../components/page'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {store} from '../../../store/store.js';
import {StorageUtil} from '../../../common/Auth.js';

export default {
    name: 'noteList',
    data() {
        return {
            noteList: [],
            idCard: store.func.getUserIdCard(),
            readerId: store.func.getUserReaderId(),
            totalPage: 1,
            pageCount: 3,
            pageNo: 1,
        }
    },
    components: {
        page
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
      store.personal._this.activeNav = "读书笔记";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.note.list.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount).replace('{idCard}', this.idCard);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
              if (data.resultList!= null) {
                    this.noteList= data.resultList;
              }
              this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        /*
          跳转到该本书所有的笔记详情
        **/
        toNoteDetail(item){
          this.$router.push({path: 'notecontent', query: { 'bookId': item.id, 'readerId': this.readerId, 'bookName': item.bookName }});
        },

    }
}
